import axios from 'axios';

const HOST_API = process.env.REACT_APP_URL;

export const getUsuarios = (administracionId) =>
    axios.get(`${HOST_API}api/usersAdm/getAll?administracionId=${administracionId}`);

export const saveUsuario = (data) =>
    axios.post(`${HOST_API}api/usersAdm/saveUsuario`, data);

export const existeUserName = (userName, usuarioId = 0) =>
    axios.get(`${HOST_API}api/usersAdm/existeUserName?userName=${encodeURIComponent(userName)}&usuarioId=${usuarioId}`);
